export default __webpack_public_path__ + "static/media/apple-sso-next.d45eec6f.svg";